var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ 
    showCanvas: Object.keys(_vm.state.ERRORS).length === 0,
    hideCanvas: Object.keys(_vm.state.ERRORS).length !== 0
  }},[_c('canvas',{attrs:{"id":"AmortizationCanvas"},on:{"click":_vm.click}})])])}
var staticRenderFns = []

export { render, staticRenderFns }